import PropTypes from 'prop-types';
import React from 'react';

export const Job = ({ department, job }) => (
  <div className="JobBoard__job">
    <a
      href={job.absolute_url}
      className="JobBoard__job-title"
      rel="noopener noreferrer"
      target="_blank"
    >
      {job.title}
    </a>
    <div className="JobBoard__job-department">{department.name}</div>
    <div className="JobBoard__job-location">{job.location.name}</div>
  </div>
);

Job.propTypes = {
  department: PropTypes.object.isRequired,
  job: PropTypes.object.isRequired,
};
